module.exports = __webpack_public_path__ + "img/c00_buildingtechdamascussteel_Normal_ua.3a4b5a18.webp";